import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: ${Spacing.S12};

  &:last-of-type {
    ${() => Number} {
      &:after {
        display: none;
      }
    }
  }
`

interface NumberProps {
  isChecked: boolean
}

export const Number = styled.div<NumberProps>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: ${Spacing.S12};
  border: 2px solid ${Color.Grey200};
  border-radius: 50%;
  position: relative;
  ${({ isChecked }) =>
    isChecked &&
    `
    border-color: ${Color.Green400};
    background-color: ${Color.Green100};
  `}

  &:after {
    content: '';
    width: 2px;
    height: 12px;
    margin-top: ${Spacing.S2};
    position: absolute;
    top: 100%;
    background: ${Color.Grey200};
  }
`
